// import React, { useState, useEffect } from 'react';
// import '../styles/EESExperience.css';
// import '../styles/EESFeedbackManagement.css';

// const EESFeedbackManagement = () => {
//     const [feedbacks, setFeedbacks] = useState([]);
//     const [selectedFeedback, setSelectedFeedback] = useState(null);
//     const [loading, setLoading] = useState(true);

//     // Categories mapping to match EESExperience surveyData structure
//     const categories = [
//         { name: "Overall Experience", icon: "🌌" },
//         { name: "Work Environment", icon: "🛰️" },
//         { name: "Leadership", icon: "👑" },
//         { name: "Motivation", icon: "🚀" },
//         { name: "Growth", icon: "📈" },
//         { name: "Rewards", icon: "💰" },
//         { name: "Wellbeing", icon: "🧘" },
//         { name: "Belonging", icon: "🤝" },
//         { name: "Feedback", icon: "💬" },
//         { name: "Retention", icon: "🛡️" }
//     ];

//     // Fetch real data from your elmsdb via the PHP API
//     const fetchFeedbacks = async () => {
//         try {
//             setLoading(true);
//             const response = await fetch('/gt-api/ees_api.php');
//             const data = await response.json();
//             // Ensure data is an array before setting state
//             setFeedbacks(Array.isArray(data) ? data : []);
//         } catch (error) {
//             console.error("Error fetching EES data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchFeedbacks();
//     }, []);

//     return (
//         <div className="management-request-wrapper animate-fade">
//             <div className="module-glass-card">
//                 <div className="card-header-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                     <h3 className="cyan-text">REAL_TIME_EES_FEEDBACK_LOGS</h3>
//                     <div className="stat-badge" style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', border: '1px solid rgba(0, 242, 255, 0.3)' }}>
//                         TOTAL_SUBMISSIONS: {feedbacks.length}
//                     </div>
//                 </div>

//                 {loading ? (
//                     <div style={{ textAlign: 'center', padding: '40px', color: '#00f2ff' }}>SYNCHRONIZING_WITH_ELMSDB...</div>
//                 ) : (
//                     <table className="cyber-table">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE</th>
//                                 <th>DEPARTMENT</th>
//                                 <th>SUBMISSION_DATE</th>
//                                 <th>ENGAGEMENT</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {feedbacks.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#666' }}>NO_FEEDBACK_ENTRIES_FOUND</td>
//                                 </tr>
//                             ) : (
//                                 feedbacks.map((fb) => (
//                                     <tr key={fb.id}>
//                                         <td>
//                                             <div className="emp-info">
//                                                 <span style={{ fontWeight: 'bold', display: 'block', color: '#fff' }}>{fb.employee_name}</span>
//                                                 <small style={{ color: '#00f2ff', opacity: 0.7 }}>{fb.employee_id}</small>
//                                             </div>
//                                         </td>
//                                         <td>{fb.department}</td>
//                                         <td>{new Date(fb.submission_date).toLocaleDateString()}</td>
//                                         <td>
//                                             <span className="cyan-text" style={{ fontWeight: 'bold' }}>{fb.score_percent}</span>
//                                         </td>
//                                         <td>
//                                             <button 
//                                                 className="btn-action view-btn" 
//                                                 style={{ background: 'rgba(0, 242, 255, 0.1)', border: '1px solid #00f2ff', color: '#00f2ff', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
//                                                 onClick={() => setSelectedFeedback(fb)}
//                                             >
//                                                 VIEW_REPORT
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* FULL REPORT MODAL */}
//             {selectedFeedback && (
//                 <div className="ees-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.9)', backdropFilter: 'blur(10px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 }}>
//                     <div className="ees-modal-content" style={{ background: '#0a0c10', border: '1px solid rgba(0, 242, 255, 0.2)', width: '90%', maxWidth: '700px', maxHeight: '85vh', borderRadius: '20px', padding: '30px', display: 'flex', flexDirection: 'column', color: '#fff' }}>

//                         <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
//                             <div>
//                                 <h2 style={{ margin: 0 }}>Survey Analysis</h2>
//                                 <p className="cyan-text" style={{ margin: '5px 0 0', fontSize: '14px' }}>{selectedFeedback.employee_name} // {selectedFeedback.employee_id}</p>
//                             </div>
//                             <button onClick={() => setSelectedFeedback(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '24px', cursor: 'pointer' }}>×</button>
//                         </div>

//                         <div className="modal-body" style={{ overflowY: 'auto', padding: '20px 0' }}>
//                             <div className="category-report-grid">
//                                 {categories.map((cat, catIdx) => (
//                                     <div key={cat.name} style={{ marginBottom: '15px', padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
//                                         <h4 style={{ fontSize: '11px', textTransform: 'uppercase', color: '#888', margin: '0 0 10px 0', letterSpacing: '1px' }}>
//                                             {cat.icon} {cat.name}
//                                         </h4>
//                                         <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
//                                             {[...Array(10)].map((_, qIdx) => {
//                                                 // Accessing the nested responses JSON object
//                                                 const score = selectedFeedback.responses[`${catIdx}-${qIdx}`];
//                                                 if (!score) return null;

//                                                 // Dynamic color based on score
//                                                 const colors = { 5: '#00ff88', 4: '#00f2ff', 3: '#f59e0b', 2: '#f43f5e', 1: '#661010' };

//                                                 return (
//                                                     <div key={qIdx} style={{ 
//                                                         width: '28px', height: '28px', borderRadius: '6px', 
//                                                         display: 'flex', alignItems: 'center', justifyContent: 'center', 
//                                                         fontWeight: 'bold', fontSize: '12px', background: colors[score], color: score === 1 ? '#fff' : '#000' 
//                                                     }}>
//                                                         {score}
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>

//                         <button 
//                             className="close-btn" 
//                             style={{ width: '100%', padding: '12px', background: '#00f2ff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' }}
//                             onClick={() => setSelectedFeedback(null)}
//                         >
//                             CLOSE_ANALYSIS
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default EESFeedbackManagement;









import React, { useState, useEffect } from 'react';
import '../styles/EESExperience.css';
import '../styles/EESFeedbackManagement.css';

const EESFeedbackManagement = () => {
    const [feedbacks, setFeedbacks] = useState([]);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [loading, setLoading] = useState(true);

    // The lookup table for questions (Must match the order in EESExperience)
    const surveyData = [
        { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
        { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
        { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
        { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
        { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
        { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
        { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
        { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
        { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
        { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
    ];

    const fetchFeedbacks = async () => {
        try {
            setLoading(true);
            const response = await fetch('/gt-api/ees_api.php');
            const data = await response.json();
            setFeedbacks(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error fetching EES data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedbacks();
    }, []);

    const getScoreColor = (score) => {
        const colors = { 5: '#00ff88', 4: '#00f2ff', 3: '#f59e0b', 2: '#f43f5e', 1: '#661010' };
        return colors[score] || '#333';
    };

    return (
        <div className="management-request-wrapper animate-fade">
            <div className="module-glass-card">
                <div className="card-header-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    {/* <h3 className="cyan-text">Employee Experience Survey - EES_LOGS</h3> */}
                    <h3 className="cyan-text" style={{
                        fontSize: '20px',          // Increased size
                        fontWeight: 'bold',
                        letterSpacing: '2px',      // Cleaner, more "tech" look
                        textTransform: 'uppercase',
                        textShadow: '0 0 10px rgba(0, 242, 255, 0.5)', // Subtle glow
                        margin: 0
                    }}>
                        EMPLOYEE_EXPERIENCE_SURVEY_LOGS
                    </h3>
                    <div className="stat-badge" style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '5px 15px', borderRadius: '20px', fontSize: '14px', border: '1px solid rgba(0, 242, 255, 0.3)' }}>
                        TOTAL_SUBMISSIONS: {feedbacks.length}
                    </div>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#00f2ff' }}>SYNCHRONIZING_WITH_ELMSDB...</div>
                ) : (
                    <table className="cyber-table">
                        <thead>
                            <tr>
                                <th>EMPLOYEE</th>
                                <th>DEPARTMENT</th>
                                <th>SUBMISSION_DATE</th>
                                <th>ENGAGEMENT</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {feedbacks.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#666' }}>NO_FEEDBACK_ENTRIES_FOUND</td>
                                </tr>
                            ) : (
                                feedbacks.map((fb) => (
                                    <tr key={fb.id}>
                                        <td>
                                            <div className="emp-info">
                                                <span style={{ fontWeight: 'bold', display: 'block', color: '#fff' }}>{fb.employee_name}</span>
                                                <small style={{ color: '#00f2ff', opacity: 0.7 }}>{fb.employee_id}</small>
                                            </div>
                                        </td>
                                        <td>{fb.department}</td>
                                        <td>{new Date(fb.submission_date).toLocaleDateString()}</td>
                                        {/* <td><span className="cyan-text" style={{ fontSize: '14px', fontWeight: 'bold'  }}>{fb.score_percent}</span></td> */}

                                        <td style={{ textAlign: 'center' }}>
                                            <span
                                                className="cyan-text"
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    display: 'block' // Ensures it fills the cell width for centering
                                                }}
                                            >
                                                {fb.score_percent}
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                className="btn-action view-btn"
                                                style={{ background: 'rgba(0, 242, 255, 0.1)', border: '1px solid #00f2ff', color: '#00f2ff', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                                                onClick={() => setSelectedFeedback(fb)}
                                            >
                                                VIEW_REPORT
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}
            </div>



            {/* FULL REPORT MODAL */}
            {selectedFeedback && (
                <div className="ees-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(10px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 }}>
                    <div className="ees-modal-content" style={{
                        background: '#0a0c10',
                        border: '1px solid rgba(0, 242, 255, 0.2)',
                        width: '95%',
                        maxWidth: '900px',
                        height: '90vh',      // Fixed height for the card
                        borderRadius: '20px',
                        padding: '30px',
                        display: 'flex',
                        flexDirection: 'column', // Stack Header, Body, and Footer vertically
                        color: '#fff',
                        position: 'relative'
                    }}>

                        {/* 1. FIXED HEADER */}
                        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px', flexShrink: 0 }}>
                            <div>
                                <h2 style={{ margin: 0 }}>Detailed Neural Analysis</h2>
                                <p className="cyan-text" style={{ margin: '5px 0 0', fontSize: '14px' }}>{selectedFeedback.employee_name} ({selectedFeedback.employee_id})</p>
                            </div>
                            <button onClick={() => setSelectedFeedback(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '32px', cursor: 'pointer' }}>×</button>
                        </div>

                        {/* 2. SCROLLABLE BODY */}
                        <div className="modal-body" style={{
                            overflowY: 'auto',   // This area scrolls
                            padding: '20px 0',
                            flexGrow: 1          // Takes up all available space between header and footer
                        }}>
                            {surveyData.map((catObj, catIdx) => (
                                <div key={catObj.cat} style={{ marginBottom: '30px' }}>
                                    <h3 style={{ color: '#00f2ff', borderLeft: '4px solid #00f2ff', paddingLeft: '15px', textTransform: 'uppercase', fontSize: '16px', letterSpacing: '2px', marginBottom: '15px' }}>
                                        {catObj.icon} {catObj.cat}
                                    </h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {catObj.questions.map((qText, qIdx) => {
                                            const score = selectedFeedback.responses[`${catIdx}-${qIdx}`];
                                            return (
                                                <div key={qIdx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(255,255,255,0.03)', padding: '12px 20px', borderRadius: '8px' }}>
                                                    <span style={{ fontSize: '14px', color: '#ccc' }}>{qText}</span>
                                                    <span style={{ background: getScoreColor(score), color: '#000', width: '30px', height: '30px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>{score}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* 3. FIXED FOOTER AT BOTTOM */}
                        <div className="modal-footer" style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '20px',
                            borderTop: '1px solid rgba(255,255,255,0.1)',
                            flexShrink: 0 // Prevents footer from squishing
                        }}>
                            <button
                                onClick={() => setSelectedFeedback(null)}
                                style={{
                                    width: 'auto',
                                    minWidth: '180px',
                                    padding: '12px 30px',
                                    background: '#00f2ff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    color: '#000',
                                    fontSize: '13px',
                                    letterSpacing: '1px'
                                }}
                            >
                                CLOSE_ANALYSIS
                            </button>
                        </div>
                    </div>
                </div>
            )}



        </div>
    );
};

export default EESFeedbackManagement;